export default "__VITE_ASSET__b47f7abe__"